export const POPULAR_LIST_TITLES = {
  suburban_sale: {
    text: 'Продажа',
    url: '/cat.php?deal_type=sale&engine_version=2&object_type%5B0%5D=1&object_type%5B1%5D=2&object_type%5B2%5D=3&object_type%5B3%5D=4&offer_type=suburban',
  },
  suburban_rent: {
    text: 'Аренда',
    url: '/cat.php?deal_type=rent&engine_version=2&object_type%5B0%5D=1&object_type%5B1%5D=2&object_type%5B2%5D=4&offer_type=suburban',
  },
};
